var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactContour(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#0E3E28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.333,64H42.667C19.135,64,0,83.135,0,106.667v298.667C0,428.865,19.135,448,42.667,448h426.667         C492.865,448,512,428.865,512,405.333V106.667C512,83.135,492.865,64,469.333,64z M42.667,85.333h426.667         c1.168,0,2.177,0.486,3.294,0.667L267.333,252.677c-6.938,4.385-16.854,3.677-21.906,0.563L39.365,86.003         C40.484,85.82,41.496,85.333,42.667,85.333z M490.667,405.333c0,11.76-9.573,21.333-21.333,21.333H42.667         c-11.76,0-21.333-9.573-21.333-21.333V106.667c0-2.385,0.637-4.585,1.362-6.728l210.221,170.54         c6.927,4.479,14.917,6.854,23.083,6.854c7.875,0,15.563-2.198,22.313-6.375c0.625-0.323,1.219-0.708,1.76-1.156l209.23-169.868         c0.727,2.145,1.363,4.346,1.363,6.733V405.333z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactContour);
export default __webpack_public_path__ + "static/media/contact-contour.39086fdb961f52fc4f4c2b04b7718a5b.svg";
export { ForwardRef as ReactComponent };